import { createBrowserRouter } from "react-router-dom";
import RequireAuth from "../auth/RequireAuth";
import Dashboard from "../Component/dashboard/Dashboard";
import Home from "../Component/Home/Home";
import About from "../Component/Pages/About/About";
import Login from "../Component/Pages/authentication/Login";
import SignUp from "../Component/Pages/authentication/SignUp";
import Blog from "../Component/Pages/Blogs/Blog";
import Contact from "../Component/Pages/Contact/Contact";
import Course from "../Component/Pages/Course/Course";
import CourseDetails from "../Component/Pages/Course/CourseDetails";
import FAQs from "../Component/Pages/FAQs/FAQs";

import Portfolio from "../Component/Pages/Portfolio/Portfolio";
import PortfolioAll from "../Component/Pages/Portfolio/PortfolioAll";
import Services from "../Component/Pages/Services/Services";
import ServicesDetails from "../Component/Pages/Services/ServicesDetails";
import SubCategoriesServicesDetails from "../Component/Pages/Services/SubCategoriesServicesDetails";
import Shop from "../Component/Pages/Shop/Shop";
import Profile from "../Component/dashboard/Profile/Profile";
import NoteFoundPage from "../Component/Shear/NoteFoundPage";
import MyClass from "../Component/dashboard/UserDashboard/my_class/MyClass";
import CourseLesson from "../Component/dashboard/UserDashboard/course_lesson/CourseLesson";
import AllUser from "../Component/dashboard/AdminDashboard/AllUser/AllUser";
import RequireAdmin from "../auth/RequireAdmin";
import MyOrder from "../Component/dashboard/UserDashboard/MyOrder";
import AddFeedback from "../Component/dashboard/UserDashboard/AddFeedback";
import BlogDetails from "../Component/Shear/blog/BlogDetails";
import Checkout from "../pages/checkout/Checkout";
import OtpBox from "../Component/Ui/OtpBox";
import TermsCondition from "../Component/Pages/TermsCondition";
import WebDevelopmentCourse from "../Component/Pages/Course/WebDevelopmentCourse";
import PrivacyPolicy from "../Component/Pages/PrivacyPolicy";
import BikashError from "../Component/Shear/Erros/BikashError";
import BikashSuccess from "../Component/Shear/SuccessMessage/BikashSuccess";
import Student from "../Component/dashboard/AdminDashboard/Student/Student";
import Order from "../Component/dashboard/AdminDashboard/Order/Order";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <NoteFoundPage />,
  },
  {
    path: "/service",
    element: <Services />,
  },
  {
    path: "/service/:slug",
    element: <ServicesDetails />,
  },
  {
    path: "/categories/:slug",
    element: <SubCategoriesServicesDetails />,
  },
  {
    path: "/terms-and-condition",
    element: <TermsCondition />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },

  {
    path: "/portfolio",
    element: <Portfolio />,
    children: [
      {
        path: "/portfolio",
        element: <PortfolioAll />,
      },
    ],
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog-details/:id",
    element: <BlogDetails />,
  },
  {
    path: "/course",
    element: <Course />,
  },

  {
    path: "/course/:slug",
    element: <WebDevelopmentCourse />,
  },

  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/faqs",
    element: <FAQs />,
  },
  // shop
  {
    path: "/shop",
    element: <Shop />,
  },

  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <SignUp />,
  },
  {
    path: "/checkout/:slug",
    element: (
      <RequireAuth>
        <Checkout />
      </RequireAuth>
    ),
  },

  // dashboard

  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
    children: [
      {
        path: "/dashboard",
        element: (
          <RequireAuth>
            {" "}
            <Profile />
          </RequireAuth>
        ),
      },
      {
        path: "/dashboard/class",
        element: (
          <RequireAuth>
            {" "}
            <MyClass />
          </RequireAuth>
        ),
      },
      {
        path: "/dashboard/my_order",
        element: (
          <RequireAuth>
            {" "}
            <MyOrder />
          </RequireAuth>
        ),
      },
      {
        path: "/dashboard/add_feedback",
        element: (
          <RequireAuth>
            {" "}
            <AddFeedback />
          </RequireAuth>
        ),
      },

      // admin
      {
        path: "/dashboard/all_user",
        element: (
          <RequireAdmin>
            <AllUser />
          </RequireAdmin>
        ),
      },
      {
        path: "/dashboard/students",
        element: (
          <RequireAdmin>
            <Student />
          </RequireAdmin>
        ),
      },
      {
        path: "/dashboard/admissions",
        element: (
          <RequireAdmin>
            <Order />
          </RequireAdmin>
        ),
      },
    ],
  },

  // class
  {
    path: "/course-lesson-view",
    element: <CourseLesson />,
  },
  {
    path: "/verification",
    element: <OtpBox />,
  },
  {
    path: "/error?",
    element: <BikashError />,
  },
  {
    path: "/success",
    element: <BikashSuccess />,
  },
]);

export default routes;
